import React from 'react';
import { useLocation } from 'react-router-dom';
import { LoadingScreen } from '@/components/LoadingScreen';
import { useAuth } from '@/app/providers/AuthProvider';
import { useMaintenance } from '@/app/providers/MaintenanceProvider';
import { canAccessPlatformAdmin } from '@/components/auth/platformAdminAccess';
import { normalizeMaintenancePathname } from '@/app/router/maintenanceHubMap';
import MaintenancePage from '@/pages/MaintenancePage';

export function MaintenanceGate({ children }: { children: React.ReactElement }) {
  const location = useLocation();
  const { user, loading: authLoading, isAdmin, isPlatformAdmin, isSuperAdmin } = useAuth();
  const { state, loading: maintenanceLoading } = useMaintenance();
  const pathname = normalizeMaintenancePathname(location.pathname);

  if (pathname === '/login' || pathname === '/forbidden') return children;

  if (authLoading || maintenanceLoading) {
    return <LoadingScreen message="Verifica autenticazione e stato manutenzione..." fullScreen={true} />;
  }

  if (!user || !state.global.enabled) return children;

  const legacyFallbackEnabled = import.meta.env.VITE_ALLOW_LEGACY_ADMIN_FALLBACK !== 'false';
  const canBypass = canAccessPlatformAdmin({
    platformAccessVerified: user.platformAccessVerified,
    isSuperAdmin,
    isPlatformAdmin,
    platformAdminAreas: user.platformAdminAreas,
    isAdmin,
    isLegacyAdmin: user.isLegacyAdmin,
    legacyFallbackEnabled,
  });

  return canBypass ? children : <MaintenancePage />;
}
